'use strict';

var pdfMake = require('pdfmake/build/pdfmake.min');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import 'angular-socket-io';

import uiRouter from 'angular-ui-router';

import {
  routeConfig,
  themeConfig,
  accessibilityWidgetConfig,
  decorateTextAngular,
  stripeElementsConfig
} from './app.config';

import account from './account';
import admin from './admin';
import bulletin from './bulletin';
import business from './business';
import calendar from './calendar';
import constants from './app.constants';
import directories from './directories';
import documents from './document';
import forum from './forum';
import gallery from './gallery';
import home from './home';
import main from './main';
import messaging from './messaging';
import news from './news';
import piper from './piper';
import profile from './user';
import serviceRequests from './service-requests';
import reservation from './reservation';
import eForm from './e-form';
import survey from './survey';
import payment from './payment';

import UploadArchive from './upload/archive/upload-archive.component';
import SearchResultComponent from './search/result/search-result.component';
import UserInsightsComponent from './superadmin/user-insights/user-insights.component';

import components from '../components';
import AppConfigService from '../services/config/config.service';

import './app.scss';

import deferredBootstrapper from 'angular-deferred-bootstrap/angular-deferred-bootstrap';

import ApplicationPlatform from '../~ap';
import SharedModules from '../~sm';

import MemoryGameComponent from './games/memory/memoryGame.component';
import LeaderboardService from '../services/leaderboard/leaderboard.service';

import '../components/ng-cart/ng-cart';
import ShopComponent from './shop/shop.component';

import MapComponent from '../components/map/map.component';

import 'angular-ui-grid/ui-grid.min';
import 'angular-ui-grid/ui-grid.edit.min';
import 'angular-ui-grid/ui-grid.selection.min';
import 'angular-ui-grid/ui-grid.cellnav.min';

import 'angular-ui-grid/ui-grid.min.css';

import 'checklist-model/checklist-model';

import ImageEditorComponent from '../components/image-editor/image-editor.component';
import ImageEditorScaleComponent from '../components/image-editor-scale/image-editor-scale.component';

import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min';
import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle.min.css';

import 'angular-tree-control/angular-tree-control';
import 'angular-tree-control/context-menu';

import 'angular-tree-control/css/tree-control.css';
import 'angular-tree-control/css/tree-control-attribute.css';

import 'ng-csv/build/ng-csv.min';
import DigitalSignageComponent from './digital-signage/digital-signage.component';

import 'ng-tags-input/build/ng-tags-input.min';
import 'ng-tags-input/build/ng-tags-input.min.css';
import 'ng-tags-input/build/ng-tags-input.bootstrap.min.css';

import 'ngstorage/ngStorage.min';

import './digital-signage/ngprogress.min';
import './digital-signage/ngprogress.css';

/*
import 'pdfmake/build/pdfmake.min';
import 'pdfmake/build/vfs_fonts';
*/

var $stateProviderRef = null;

// https://github.com/wix/angular-tree-control/issues/165
// define 'treeControl' before anuglar-ui-tree to prevent collissions

angular.module('conduuApp', [ngCookies, ngResource, 'btford.socket-io', uiRouter,

  ApplicationPlatform, SharedModules, 'treeControl', components,

  account, admin, bulletin, business, calendar, constants, directories, documents, forum, gallery, home, main,
  messaging, news, piper, profile, serviceRequests, reservation, eForm, survey, payment,

  UploadArchive, SearchResultComponent, UserInsightsComponent, AppConfigService, MapComponent,
  MemoryGameComponent, LeaderboardService, 'ngCart', ShopComponent, 'ui.grid', 'ui.grid.edit', 'ui.grid.selection',
  'ui.grid.cellNav', 'checklist-model', ImageEditorComponent, ImageEditorScaleComponent, 'ui.toggle', 'ngCsv',
  DigitalSignageComponent, 'ngTagsInput', 'ngStorage', 'ngProgress'
])
  .config(themeConfig)
  .config(routeConfig)
  .config(decorateTextAngular)
  .config(stripeElementsConfig)
  .config(accessibilityWidgetConfig)
  .config(['$provide', function ($provide){
    'ngInject';

    /* Hack to bring UI Bootstrap's Accordeon and UI Sortable together
     * https://stackoverflow.com/questions/26520131/how-can-i-create-a-sortable-accordion-with-angularjs */
    $provide.decorator('uibAccordionDirective', function($delegate) {
      var directive = $delegate[0];
      directive.replace = true;
      return $delegate;
    });
  }])
  .config(function($stateProvider) {
    'ngInject';
    $stateProviderRef = $stateProvider;
  })
  .run(function($rootScope, $location, $window, Auth, editableOptions, Config, $cookieStore) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {

          // store the requested url if not logged in
          if ($location.url() != '/login')
          {
            $cookieStore.put('returnUrl', $location.url());
          }

          $location.path('/login');
        }
      });
    });

    editableOptions.theme = 'bs3';  // xeditable theme = bootstrap 3

    // Piwik Page Id
    let analyticsId = Config.getPlatformConfig().getAnalyticsId();
    if ($window._paq && analyticsId) {
      $window._paq.push(['setSiteId', analyticsId]);
    }
    
    var newsCategories = Config.getModuleConfig(Config.Modules.News).getTypes();

    newsCategories.forEach(type => {
      $stateProviderRef
        .state(type+'-news-list', {
          url: '/'+type+'/list',
          template: '<news-list type="'+type+'"></news-list>',
          authenticate: true
        });

      $stateProviderRef
        .state(type+'-news-show', {
          url: '/'+type+'/:id',
          template: '<news-show type="'+type+'"></news-show>',
          authenticate: true
        });

      $stateProviderRef
        .state(type+'-news-edit', {
          url: '/'+type+'/edit/:id',
          template: '<news-edit type="'+type+'"></news-edit>',
          authenticate: 'admin'
        });
    });

    var galleryCategories = Config.getModuleConfig(Config.Modules.Gallery).getTypes();

    galleryCategories.forEach(type => {
      $stateProviderRef
        .state(type+'-gallery-list', {
          url: '/gallery/list/'+type,
          template: '<gallery-list type="'+type+'"></gallery-list>',
          authenticate: true
        })
    });

    galleryCategories.forEach(type => {
      $stateProviderRef
        .state(type+'-gallery-list-public', {
          url: '/public/gallery/list/'+type,
          template: '<gallery-list public="true" type="'+type+'"></gallery-list>'
        })
    });

    var calendarEventCategories = Config.getModuleConfig(Config.Modules.Calendar).getEventTypes();

    calendarEventCategories.forEach(type => {
      $stateProviderRef
        .state('calendar-'+type+'-list', {
          url: '/calendar/'+type+'/list',
          template: '<calendar-list type="'+type+'"></calendar-list>',
          authenticate: true
        })
    });

    var reservationCategories = [];
    try {
      reservationCategories = Config.getModuleConfig(Config.Modules.Reservation).getTypes();
    }catch(e) {}

    reservationCategories.forEach(type => {

      $stateProviderRef
        .state('reservation-'+type+'-list', {
          url: '/reservation/'+type+'/list',
          template: '<reservation-list type="'+type+'"></reservation-list>',
          authenticate: true
        });

      $stateProviderRef
        .state('reservation-'+type+'-admin', {
          url: '/reservation/'+type+'/admin',
          template: '<reservation-admin type="'+type+'"></reservation-admin>',
          authenticate: 'admin'
        });
    });

    var eventCategories = [];
    try {
      eventCategories = Config.getModuleConfig(Config.Modules.Reservation).getEventTypes();
    }catch(e) {}

    eventCategories.forEach(type => {

      $stateProviderRef
        .state('event-'+type+'-list', {
          url: '/event-reservation/'+type+'/list',
          template: '<event-reservation-list type="'+type+'"></event-reservation-list>',
          authenticate: true
        });

      $stateProviderRef
        .state('event-'+type+'-admin', {
          url: '/event-reservation/'+type+'/admin/:id',
          template: '<event-reservation-admin type="'+type+'"></event-reservation-admin>',
          authenticate: 'admin'
        });

    });

    var eventCalendarTypes = [];
    try {
      let _calendarConfig = Config.getModuleConfig(Config.Modules.Reservation).getCalendarConfig();
      eventCalendarTypes = Object.keys(_calendarConfig);
    }catch(e) {}

    eventCalendarTypes.forEach(type => {

      $stateProviderRef
        .state('event-calendar-' + type, {
          url: '/event-calendar/' + type,
          template: '<event-calendar type="'+type+'"></event-calendar>',
          authenticate: true
        });

    });

    var calendarGroups = [];
    try {
      let _calendarGroups = Config.getModuleConfig(Config.Modules.Calendar).getCalendarGroup();
      calendarGroups = Object.keys(_calendarGroups);
    }catch(e) {}

    calendarGroups.forEach(group => {

      $stateProviderRef
        .state('calendar-' + group + '-group', {
          url: '/calendar/group/' + group,
          template: '<calendar-list group="'+group+'"></calendar-list>',
          authenticate: true
        });

    });

    var frontLevelPages = Config.getModuleConfig(Config.Modules.General).getFrontLevelPages();

    frontLevelPages.forEach(flPage => {

      $stateProviderRef
        .state('public-dynamic-page-' + flPage, {
        url: '/' + flPage,
        template: '<dynamic-page public="true" page="'+flPage+'"></dynamic-page>'
      });

    })

  });

angular.element(document)
  .ready(() => {

    deferredBootstrapper.bootstrap({
      element: document.body,
      module: 'conduuApp',
      bootstrapConfig: {
        strictDi: true
      },
      resolve: {
        PLATFORM_CONFIG: ['$http', function ($http) {
          return $http.get('/api/settings/public/name/config.platform');
        }],
        APP_CONFIG: ['$http', function ($http) {
          return $http.get('/api/settings/public/name/config.app');
        }],
        MENU_CONFIG: ['$http', function ($http) {
          return $http.get('/api/settings/public/name/menu');
        }],
        PUBLIC_MENU_CONFIG: ['$http', function ($http) {
          return $http.get('/api/settings/public/name/public-menu');
        }],
        CUSTOM_STYLES: ['$http', function ($http) {
          return $http.get('/api/settings/public/name/$css');
        }]
      }
    });

  });



// WEBPACK FOOTER //
// ./client/app/app.js